<nav class="preview-footer">
  <ng-content></ng-content>
</nav>
